/**
 * Trạng thái ký của user hiện tại
 */
export default {
  Signed: 1,
  NotSigned: 2,
  NoNeedToSign: 3
};
